module.exports = __webpack_public_path__ + "img/Logo@2x.8a44361a.png";